import { useCallback } from 'react'
import { useRecurrenceDispatch } from '../../../../../providers/StateProvider'
import { UpdateRecurrenceEndAction } from '../../../../../types'
import { SelectChangeEvent } from '@mui/material'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()

  return useCallback(
    (event: SelectChangeEvent<string>) => {
      dispatch({
        type: 'recurrenceEnd:change',
        recurrenceEnd: {
          endType: event.target.value as UpdateRecurrenceEndAction['recurrenceEnd']['endType'],
        },
      })
    },
    [dispatch],
  )
}
